// About.js
import React, { useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useAuth } from '../components/auth/AuthProvider';
import { Link } from 'react-router-dom';

function ServiciosPage() {
  const { token } = useAuth();
  useEffect(() => {
    document.title = 'FAMA - Servicios';
    console.log('Token: ' + token);
  }, []);
  return (
    <Container className='public-page-container servicios-page'>
      <h1>Servicios</h1>
      <Row>
        <Col md={4}>
          <img src='/alianza-matrimonial-logo.png' />
        </Col>
        <Col md={8}>
          <h2>Alianza Matrimonial</h2>
          <h3>La alianza de hoy será nuestro matrimonio del mañana.</h3>
          <p>Alianza Matrimonial es un retiro Católico diseñado para fortalecer la unión del matrimonio.
Organizado por Familias en Misión Apostólica, a través de un fin de semana guiado por la
gracia de Dios, los matrimonios son invitados a encontrarse cara a cara, a dialogar con
sinceridad y a redescubrir el amor que los unió.</p>
          <p>Inspirado en la Palabra de Dios y en la acción del Espíritu Santo, este retiro ofrece una
experiencia profunda de fe, reconciliación y compromiso. Más que una convivencia, es un
encuentro transformador con Cristo, donde cada pareja aprende a ver su matrimonio como un
reflejo vivo del amor de Dios. Regresarás a casa con un corazón renovado, listo para reflejar el
amor de Cristo y ser testimonio vivo de fe y unidad en tu matrimonio.</p>
          <p>Les gustaría disfrutar de un fin de semana en un ambiente tranquilo, con tiempo para compartir
en intimidad y en profundidad sus necesidades y deseos personales, sus miedos y
preocupaciones, sus presentes y sus esperanzas futuras?</p>
          <p>Si su respuesta es sí, entonces merecen vivir la experiencia del retiro de Alianza Matrimonial.</p>
          { token && <p>
            <Button size='lg' className='me-5' href={'/formularios/requisitos-para-iniciar-el-servicio-de-alianza-matrimonial.pdf'} target='_blank'>Requisitos</Button>
            <Button size='lg' href={'/formularios/formulario-de-solicitud-formal-para-implementar-alianza-matrimonial.pdf'} target='_blank'>Solicitud</Button>
          </p>}
        </Col>
      </Row>
      <Row>
        <Col md={{ order: 'last', span: 4}}>
          <img src='/mision-juvenil-logo.png' />
        </Col>
        <Col md={8}>
          <h2>Misión Juvenil FAMA</h2>
          <h3>Fe fuerte. Mente clara. Vida con propósito.</h3>
          <p>Misión Juvenil FAMA es un espacio creado para que adolescentes de 13 a 17 años crezcan en su fe, fortalezcan su identidad y descubran el propósito que Dios tiene para sus vidas. A través de reuniones quincenales, dinámicas, temas actuales y momentos de oración, los jóvenes aprenden a vivir su fe de manera auténtica, alegre y comprometida.</p>
          <p>El programa es acompañado por un <strong>Asesor Espiritual</strong> y guiado por <strong>matrimonios católicos formados</strong>, quienes trabajan juntos para ofrecer un ambiente seguro, cercano y profundamente humano.</p>
          <p>Aquí, los jóvenes no solo aprenden sobre Dios... <strong>lo encuentran en comunidad. Misión Juvenil FAMA es más que un programa...</strong> es una familia en misión, que acompaña y forma a la nueva generación de creyentes.</p>
          { token && <p>
            <Button size='lg' className='me-5' href={'/formularios/requisitos-para-iniciar-el-servicio-de-mision-juvenil-fama.pdf'} target='_blank'>Requisitos</Button>
            <Button size='lg' href={'/formularios/formulario-de-solicitud-formal-para-implementar-mision-juvenil-fama.pdf'} target='_blank'>Solicitud</Button>
          </p>}
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <img src='/iosef-logo.png' alt='' />
        </Col>
        <Col md={8}>
          <h2>Grupo de Niños IOSEF</h2>
          <h3>¡Forma parte del Grupo de Niños IOSEF!</h3>
          <p>El <b>Grupo de Niños IOSEF</b> es un espacio lleno de fe, alegría y crecimiento
espiritual donde los niños de <b>5 a 11</b> años aprenden a vivir los valores
cristianos y el amor de Dios en su día a día.</p>
          <p>Inspirado en el ejemplo de <b>San José</b>, este grupo busca fortalecer la
relación entre <b>padres e hijos</b>, sembrar en los niños la confianza en Dios
y ayudar a formar <b>hogares santos y felices.</b></p>
<p>Cada encuentro mensual de dos horas de actividades, cantos, juegos,
reflexión y oración, invita a los niños a descubrir que <b>“Dios añade y
provee”</b> cuando confiamos plenamente en Él.</p>
<p>A través de tres libros y nueve temas por año, el Grupo de Niños IOSEF
acompaña su crecimiento espiritual desde septiembre a mayo, formando
corazones pequeños pero llenos de fe.</p>
<p><b>Ven, únete a nosotros y deja que Dios añada alegría, fe y amor a
tu familia.</b></p>
<p>Sigamos juntos los pasos de San José, construyendo hogares guiados
por la luz de la Sagrada Familia.</p>
          { token && <p>
            <Button size='lg' className='me-5' href={'/formularios/requisitos-para-iniciar-el-servicio-de-grupo-de-ninos-iosef.pdf'} target='_blank'>Requisitos</Button>
            <Button size='lg' href={'/formularios/formulario-de-solicitud-formal-para-implementar-el-servicio-de-grupo-de-ninos-iosef.pdf'} target='_blank'>Solicitud</Button>
          </p>}
        </Col>
      </Row>
      <Row>
        <Col md={{ order: 'last', span: 4}}>
          <img src='/capacitacion-logo.png' />
        </Col>
        <Col md={8}>
          <h2>Servicio Nacional de Capacitación</h2>
          <p>¿Te gustaría servir en el llamado de Dios para ayudar a las familias en la fe, el amor y el servicio? Te ofrecemos capacitación y apoyo permanente todo el tiempo.</p>
          <p>Descubre la alegría de servir y transformar vidas con el poder del Evangelio.</p>
        </Col>
      </Row>
    </Container>
  );
}

export default ServiciosPage;
